/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import get from 'lodash.get';
import {
    withStyles,
    Grid,
    Typography,
    Button,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
} from '@material-ui/core';
import CancelPresentation from '@material-ui/icons/CancelPresentation';
import SettingsOutlined from '@material-ui/icons/SettingsOutlined';

import {
    fetchAvailableListAddonsRequest,
    fetchInstalledListAddonsRequest,
    fetchAddOnOauthAuthorizationCodeUrl,
    deleteAddOn,
    createNewAddOn,
    updateAddOn,
    openAddonDetailDrawer,
    closeAddonDetailDrawer,
} from 'Console/data/applicationDetail/settings/SettingsAction';

import {
    selectAddOnsAvailableList,
    selectAddOnsAvailableListIsLoading,
    selectAddOnsInstalledList,
    selectAddons,
    selectSelectedAddon,
} from 'Console/data/applicationDetail/settings/SettingsSelector';

import FormSelect from 'Console/components/common/form/FormSelect';
import DrawerWrapper from 'Console/components/common/drawer/DrawerWrapper';
import AddOnDetail from 'Console/components/applications/detail/settings/addOns/AddOnDetail';

import { handleDrawerWrapperToggle } from 'Console/data/app/actions';
import { selectIsDrawerWrapperShown } from 'Console/data/app/selectors';
import { ADD_ON_AUTHENTICATION_TYPE } from 'Console/constants/appConstants';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: '0 24px',
        fontSize: theme.typography.pxToRem(14),
    },
    title: {
        display: 'inline-block',
        fontWeight: 'bold',
        paddingBottom: theme.typography.pxToRem(20),
    },
    message: {
        fontSize: theme.typography.pxToRem(14),
        paddingBottom: theme.typography.pxToRem(34),
    },
    btnAdd: {
        marginTop: theme.spacing.unit + 7,
        marginLeft: theme.spacing.unit * 5 + 7,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    listItems: {
        paddingTop: theme.spacing.unit * 2 + 4,
        paddingBottom: theme.spacing.unit * 2 + 4,
    },
    listItem: {
        padding: 0,
    },
    boxList: {
        width: '45%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    formInput: {
        width: '33%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
        },
    },
});

class AddOns extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addOn: null,
            isUpdate: false,
        };
    }

    componentDidMount() {
        const {
            fetchAvailableListAddOns,
            fetchInstalledListAddOns,
            match: {
                params: { appId },
            },
        } = this.props;
        fetchAvailableListAddOns(appId);
        fetchInstalledListAddOns(appId);
    }

    handleDeleteAddOnInstalled = (addOnId) => () => {
        const { deleteAddOn } = this.props;
        deleteAddOn(addOnId);

        // @TODO to delete console.log, when will be request for delete add-on
        console.log(deleteAddOn(addOnId), 'action delete');
    };

    openDrawerWrapper = (addOnId, isUpdate = false) => () => {
        const { handleDrawerWrapperToggle, addons } = this.props;

        const addOnToAdd = addons.find((addon) => addon.descriptor.id === addOnId);
        this.setState({ addOn: addOnToAdd, isUpdate }, () => {
            handleDrawerWrapperToggle(true);
        });
    };

    openUpdateDrawerWrapper = (addOnInstanceSystemKey) => async () => {
        const {
            handleDrawerWrapperToggle,
            addons,
            fetchAddOnOauthAuthorizationCodeUrl,
            openAddonDetailDrawer,
            match: {
                params: { appId },
            },
        } = this.props;

        openAddonDetailDrawer(addOnInstanceSystemKey);

        const addOnToAdd = addons.find(
            (addon) => addon.addon_instance_system_key === addOnInstanceSystemKey
        );
        if (
            get(addOnToAdd, 'configuration.authentication.type') ===
            ADD_ON_AUTHENTICATION_TYPE.OAUTH2_AUTHORIZATION_CODE
        ) {
            await fetchAddOnOauthAuthorizationCodeUrl(
                appId,
                addOnToAdd.descriptor.systemKey,
                addOnToAdd.addon_instance_system_key
            );
        }

        this.setState({ addOn: addOnToAdd, isUpdate: true }, () => {
            handleDrawerWrapperToggle(true);
        });
    };

    closeDrawerWrapper = () => {
        const {
            form: { setFieldsValue },
            handleDrawerWrapperToggle,
            closeAddonDetailDrawer,
        } = this.props;
        this.setState({ addOn: null, isUpdate: false });
        closeAddonDetailDrawer();

        setFieldsValue({
            'addOn.name': null,
            'addOn.auth.apiKey': '',
            'addOn.auth.username': '',
            'addOn.auth.password': '',
            'addOn.auth.clientId': '',
            'addOn.auth.clientSecret': '',
        });
        handleDrawerWrapperToggle(false);
    };

    handleCreateAddOn = () => {
        const {
            form: { getFieldsValue, getFieldError, getFieldsError },
            createNewAddOn,
            intl,
        } = this.props;
        const newaddOn = getFieldsValue(['addon.authType', 'addon.name', 'addon.auth']);
        const errors = [];

        for (const error in getFieldsError()) {
            if (getFieldError(error)) {
                errors.push(getFieldError(error));
            }
        }

        createNewAddOn(newaddOn, {
            success: `${intl.formatMessage({ id: 'Notification.create.addOn.success' })}`,
            fail: `${intl.formatMessage({ id: 'Notification.create.addOn.fail' })}`,
        });

        this.closeDrawerWrapper();
    };

    handleUpdateAddOn = () => {
        const {
            form: { getFieldValue },
            updateAddOn,
            intl,
        } = this.props;
        const {
            addOn: { id },
        } = this.state;

        updateAddOn(id, getFieldValue('addon'), {
            success: `${intl.formatMessage({ id: 'Notification.save' })}`,
            fail: `${intl.formatMessage({ id: 'Notification.fail' })}`,
        });

        this.closeDrawerWrapper();
    };

    render() {
        const {
            classes,
            intl,
            addOnsAvailableList,
            addOnsAvailableListIsLoading,
            addOnsInstalledList,
            isDrawerWrapperShown,
            form,
            form: { getFieldsValue, getFieldDecorator },
            addons,
            selectedAddon,
        } = this.props;

        getFieldDecorator('addOn.installed', {
            initialValue: addOnsInstalledList || [],
            preserve: true,
        });

        const values = getFieldsValue(['addOn.name']);
        const { addOn, isUpdate } = this.state;

        return (
            <Grid container className={classes.root}>
                <Grid>
                    <DrawerWrapper
                        title={intl.formatMessage({ id: 'Settings.addOn.detail.title' })}
                        name={intl.formatMessage({ id: 'Buttons.cancel' })}
                        term={intl.formatMessage({ id: 'Buttons.create' })}
                        isShown={isDrawerWrapperShown}
                        onClose={this.closeDrawerWrapper}
                        displayButtons={false}
                    >
                        <AddOnDetail isUpdate={isUpdate} addon={selectedAddon} form={form} />
                        <Grid container justify="center" style={{ marginTop: 50 }}>
                            <Button
                                id="yeself-cancel-button"
                                color="primary"
                                onClick={this.closeDrawerWrapper}
                                style={{ color: 'rgba(0, 0, 0, 0.38)', marginRight: '1.3rem' }}
                            >
                                {intl.formatMessage({ id: 'Buttons.cancel' })}
                            </Button>

                            {!isUpdate && (
                                <Button
                                    id="yeself-install-button"
                                    style={{ marginRight: '1.3rem' }}
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleCreateAddOn}
                                >
                                    {intl.formatMessage({ id: 'Buttons.install' })}
                                </Button>
                            )}

                            {isUpdate && (
                                <Button
                                    id="yeself-uppdate-button"
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleUpdateAddOn}
                                >
                                    {intl.formatMessage({ id: 'Buttons.update' })}
                                </Button>
                            )}
                        </Grid>
                    </DrawerWrapper>
                </Grid>
                <Grid item xs={12}>
                    <Grid item>
                        <Typography variant="subtitle1" className={classes.title}>
                            {intl.formatMessage({ id: 'Settings.addOns.title' })}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1" className={classes.message}>
                            {intl.formatMessage({ id: 'Settings.addOns.message' })}
                        </Typography>
                    </Grid>

                    {!addOnsAvailableListIsLoading &&
                        addOnsAvailableList &&
                        addOnsAvailableList.length > 0 && (
                            <Grid container direction="row" alignItems="flex-end">
                                <Grid className={classes.formInput}>
                                    <FormSelect
                                        form={form}
                                        fullWidth
                                        isRequired
                                        formItemKey="addOn.name"
                                        label={intl.formatMessage({ id: 'Settings.addOns.input.label' })}
                                        optionList={addOnsAvailableList.map(
                                            ({ descriptor: { name, id } }) => ({
                                                name,
                                                id,
                                            })
                                        )}
                                        optionListIsLoading={addOnsAvailableListIsLoading}
                                    />
                                </Grid>

                                <Typography>
                                    <Button
                                        id="yeself-button"
                                        variant="contained"
                                        color="primary"
                                        className={classes.btnAdd}
                                        onClick={this.openDrawerWrapper(get(values, 'addOn.name.id'))}
                                        disabled={!values.addOn.name}
                                    >
                                        {intl.formatMessage({ id: 'Buttons.add' })}
                                    </Button>
                                </Typography>
                            </Grid>
                        )}

                    <Grid item className={classes.boxList}>
                        <List className={classes.listItems}>
                            {addons
                                .filter((addon) =>
                                    addOnsInstalledList.find(
                                        (installedAddon) => installedAddon.addon_id === addon.addon_id
                                    )
                                )
                                .map(
                                    ({
                                        addon_id,
                                        addon_instance_system_key,
                                        descriptor: { id, name },
                                    }) => (
                                        <ListItem className={classes.listItem} key={id}>
                                            <ListItemText primary={name} value={name} />
                                            <ListItemIcon>
                                                <IconButton
                                                    aria-label="Settings"
                                                    onClick={this.openUpdateDrawerWrapper(
                                                        addon_instance_system_key,
                                                        true
                                                    )}
                                                >
                                                    <SettingsOutlined />
                                                </IconButton>
                                            </ListItemIcon>
                                            <ListItemIcon>
                                                <IconButton
                                                    aria-label="Delete"
                                                    onClick={this.handleDeleteAddOnInstalled(addon_id)}
                                                >
                                                    <CancelPresentation />
                                                </IconButton>
                                            </ListItemIcon>
                                        </ListItem>
                                    )
                                )}
                        </List>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default connect(
    (state) => ({
        addOnsAvailableList: selectAddOnsAvailableList(state),
        addOnsAvailableListIsLoading: selectAddOnsAvailableListIsLoading(state),
        addOnsInstalledList: selectAddOnsInstalledList(state),
        isDrawerWrapperShown: selectIsDrawerWrapperShown(state),
        addons: selectAddons(state),
        selectedAddon: selectSelectedAddon(state),
    }),
    {
        fetchAddOnOauthAuthorizationCodeUrl,
        fetchAvailableListAddOns: fetchAvailableListAddonsRequest,
        fetchInstalledListAddOns: fetchInstalledListAddonsRequest,
        deleteAddOn,
        createNewAddOn,
        handleDrawerWrapperToggle,
        updateAddOn,
        openAddonDetailDrawer,
        closeAddonDetailDrawer,
    }
)(withStyles(styles)(injectIntl(AddOns)));
